import store from '@/store'

var baseUrl
var sasTokenString

export default {
  init () {
    baseUrl = !baseUrl ? store.getters.book.assetBaseUrl : baseUrl
    sasTokenString = !sasTokenString ? store.getters.book.sasTokenString : sasTokenString
  },
  getPreviewUrl (path, type) {
    this.init()
    return `${baseUrl}${path}${type}${sasTokenString}`
  },
  getStreamUrl (path) {
    this.init()
    return `${baseUrl}${path}${sasTokenString}`
  }
}



// WEBPACK FOOTER //
// ./src/api/asset.js